module.exports = __webpack_public_path__ + "img/ep.2cd4fe31.jpg";